module.exports = __webpack_public_path__ + "ae712d205517c02a874497f4ee259d1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heading.svg
// module id = 404
// module chunks = 0